import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'

import { useProjectChatMeListStyles } from './project-chat-me-list.styles'

export const ProjectChatMeListPlaceholder = () => {
  const classes = useProjectChatMeListStyles()

  return (
    <>
      {[...new Array(5)].map((_, i) => (
        <Card key={i} elevation={0} className={classes.root} component="a">
          <CardContent className={classes.content}>
            <Skeleton variant="rect" className={classes.cover} />
            <Typography className={classes.projectName}>
              <Skeleton width={200} />
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.categoryName}
            >
              <Skeleton width={100} />
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.date}
            >
              <Skeleton width={100} />
            </Typography>
            <Typography variant="subtitle2" className={classes.price}>
              <Skeleton width={100} />
            </Typography>
            <Typography variant="body2" className={classes.message}>
              <Skeleton />
            </Typography>
          </CardContent>
        </Card>
      ))}
    </>
  )
}
